define('transitions/renderWhenReady',['durandal/system', 'jquery', 'common/tools'], function(system, $, tools) {


    /**
     * @class RenderWhenReady
     * @constructor
     */
    var RenderWhenReady = function(context) {
        return system.defer(function(dfd) {

            if (context.activeView) {
                $(context.activeView).css({opacity:0});
            }

            if (context.child) {

                if (context.composingNewView) {
                    // if we are composing a new view then hide it until it has composed to remove jankyness
                    tools.addHook(context.model, 'compositionComplete', function() {
                        $(context.child).css({opacity: 1});
                    });

                    $(context.child).css({opacity:0});
                } else {
                    $(context.child).css({opacity: 1});
                }
            }

            dfd.resolve();

        }).promise();
    };

    return RenderWhenReady;
});
